import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['relative', 'pb-0.8']);

export const cvaRange = cva([
  'flex items-center absolute left-2.4 right-2.4 bottom-0.7',
  'w-auto h-0.2',
  '[-webkit-overflow-scrolling:touch] [touch-action:pan-x]',
]);

export const cvaRangeTrack = cva(['h-0.2 w-full']);

export const cvaRangeThumb = cva([
  'h-1.6 w-1.6 rounded-full',
  '!outline-none',
  'bg-cWhite shadow-none !border-[0.5rem] border-cMediumGreen',
]);

export const cvaInputs = cva([
  'flex justify-between gap-2.4',
  'relative',
  'px-2.4',
  'h-4.8',
  'bg-cLightGrey',
  'rounded-[1.6rem]',
  'before:absolute before:w-1.6 before:h-0.1 before:bg-cBlack32 before:left-1/2 before:top-1/2 before:-translate-x-1/2',
]);

export const cvaInputWrap = cva(['relative w-auto']);

export const cvaInput = cva(
  ['block h-4.8 w-full', 'bg-transparent outline-none border-none', 'text-bodyM text-[#213D38]'],
  {
    variants: {
      last: {
        true: ['text-right'],
        false: ['text-left'],
      },
    },
    defaultVariants: {
      last: false,
    },
  }
);

export const cvaInputClear = cva([
  'absolute z-[1] right-0 top-1/2 -translate-y-1/2',
  'fill-cGrayLine',
  'transition-fill duration-300 cursor-pointer',
  '',
]);
